import { DeleteOutlined, EditOutlined, PlusOutlined, SaveOutlined, SendOutlined, UploadOutlined } from '@ant-design/icons';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import type { RadioChangeEvent } from 'antd';
import { Button, Checkbox, Col, DatePicker, Form, Input, Radio, Row, Space, Table, Tabs, Upload } from 'antd';
import Column from 'antd/es/table/Column';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import DanhSachNhanVienTheoDonViTableModal from "../../components/modal/DanhSachNhanVienTheoDonViTableModal";
import { trangThaiLopDaoTao, urlAdmin } from "../../constants";
import { Links } from '../../helpers/Links';
import { arrayCommon, currencyFormat, dateCommon, validateMessages } from "../../helpers/common";
import { LopDaoTao, NhanVienTheoLopDaoTao } from "../../models/daotao/LopDaoTao";
import { LogNguoiDung } from '../../models/lognguoidung/LogNguoiDung';
import { TaiLieu } from "../../models/nhanvien/TaiLieu";
import { layChanhVPDuyetTongHopDaoTao, layChiTiet, layGiamDocDuyetTongHopDaoTao, layPhoCVPDuyetTongHopDaoTao, layPhoGiamDocDuyetTongHopDaoTao, luuLopDaoTao } from "../../services/daotao";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import LogNguoiDungTable from '../utils/LogNguoiDungTable';
import NhanVienSelectBox from '../utils/NhanVienSelectBox';
import TrangThaiLopDaoTaoTag from './TrangThaiLopDaoTaoTag';

const ChiTietLopDaoTao = () => {
    const params = new URLSearchParams(window.location.search)
    let id = params.get('id') || '0';
    let navigate = useNavigate();
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const [trangThai, setTrangThai] = useState<number>(trangThaiLopDaoTao.khoiTao);
    const [lyDo, setLyDo] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [themMoi, setThemMoi] = useState(true);
    const [title, setTitle] = useState("Thêm mới lớp đào tạo");
    const [activeTab, setActiveTab] = useState<string>("1");
    const [openModalLuu, setOpenModalLuu] = useState(false);
    const [valueRadio, setValueRadio] = useState(2);
    const [data, setData] = useState<LopDaoTao>(new LopDaoTao);
    const user = useSelector((state: any) => state.auth.currentUser);
    const [dsNhanVien, setDsNhanVien] = useState<Array<NhanVienTheoLopDaoTao>>([]);
    const [showModalDSNV, setShowModalDSNV] = useState(false);
    const [isEdditing, setIsEdditing] = useState(false);
    const dispatch = useDispatch();

    const [logs, setLogs] = useState<Array<LogNguoiDung>>([]);
    const [editingNV, setEditingNV] = useState<NhanVienTheoLopDaoTao>(new NhanVienTheoLopDaoTao);
    const [rowIndex, setRowIndex] = useState(-1);
    const [formNV] = Form.useForm();
    const [phoCVP, setPhoCVP] = useState<any>(null);
    const [isTrinhPhoCVP, setIsTrinhPhoCVP] = useState(false);
    const [isTrinhPhoGD, setIsTrinhPhoGD] = useState(false);
    const [phoGD, setPhoGD] = useState<any>(null);
    const [isTrinhCVP, setIsTrinhCVP] = useState(false);
    const [chanhVP, setChanhVP] = useState<any>(null);
    const [isTrinhGD, setIsTrinhGD] = useState(false);
    const [giamDoc, setGiamDoc] = useState<any>(null);

    const [isTrinh, setIsTrinh] = useState(false);

    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);
    const uploadProps: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var idTaiLieu = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoa([...idsTaiLieuXoa, idTaiLieu]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            const dinhDangHoTro = [".doc", ".docx", ".pdf", ".xls", ".xlsx", ".png", ".jpg"];
            const dinhDang = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
            if (!dinhDangHoTro.includes(dinhDang)) {
                toast.warning("Hệ thống chỉ hỗ trợ các định dạng: " + dinhDangHoTro.join(", "));
            } else if (file.size > maxSize) {
                toast.warning('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };

    const layDuLieuPhoCVP = async () => {
        try {
            let rs = await layPhoCVPDuyetTongHopDaoTao();
            setPhoCVP(rs);
        }
        catch (error: any) {
        };
    }
    const layDuLieuPhoGiamDoc = async () => {
        try {
            let rs = await layPhoGiamDocDuyetTongHopDaoTao();

            setPhoGD(rs);
        }
        catch (error: any) {
        };
    }
    const layDuLieuChanhVP = async () => {
        try {
            let rs = await layChanhVPDuyetTongHopDaoTao();
            setChanhVP(rs);
        }
        catch (error: any) {
        };
    }
    const layDuLieuGiamDoc = async () => {
        try {
            let rs = await layGiamDocDuyetTongHopDaoTao();
            setGiamDoc(rs);
        }
        catch (error: any) {
        };
    }
    const submitLuu = async (value: any) => {
        try {
            setIsEdditing(false);
            setRowIndex(-1);
            dispatch(showLoadingScreen());
            var id = await luuLopDaoTao({ ...value, lyDo: lyDo });
            setOpenModalLuu(false);
            dispatch(showLoadingScreen());
            toast.success(isTrinh ? isPheDuyet ? "Lưu thông tin lớp đào tạo đã được duyệt thành công": "Trình lớp đào tạo thành công" : themMoi ? 'Tạo mới lớp đào tạo thành công!' : 'Cập nhật lớp đào tạo thành công!');
            dispatch(hideLoadingScreen());

            navigate(Links.DaoTao.Xem + "?id=" + id);
        }
        catch (error: any) {
            setLoading(false);
            dispatch(hideLoadingScreen());
            setOpenModalLuu(false);
            toast.error(error.message || "Vui lòng thử lại");
        };
    };

    const layCT = async (id: number) => {
        setLoading(true);
        dispatch(showLoadingScreen());
        try {
            var data = await layChiTiet(id);
            setLogs(data.logs || []);
            if (data.idPhoCVP > 0) {
                setIsTrinhPhoCVP(true);
                setPhoCVP({
                    "id": data.idPhoCVP,
                    "hoTen": data.tenPhoCVP
                });
            } else {
                layDuLieuPhoCVP();
            }
            if (data.idPhoGiamDoc > 0) {
                setIsTrinhPhoGD(true);
                setPhoGD({
                    "id": data.idPhoGiamDoc,
                    "hoTen": data.tenPhoGiamDoc
                });
            } else {
                layDuLieuPhoGiamDoc();
            }
            if (data.idChanhVP > 0) {
                setIsTrinhCVP(true);
                setChanhVP({
                    "id": data.idChanhVP,
                    "hoTen": data.tenChanhVP
                });
            } else {
                layDuLieuChanhVP();
            }
            if (data.idGiamDoc > 0) {
                setIsTrinhGD(true);
                setGiamDoc({
                    "id": data.idGiamDoc,
                    "hoTen": data.tenGiamDoc
                });
            } else {
                layDuLieuGiamDoc();
            }
            if (data.id > 0) {
                form.setFieldsValue({
                    id: data?.id,
                    ma: data?.ma,
                    idNVTheoDoi: data?.idNVTheoDoi,
                    ten: data?.ten,
                    moTa: data?.moTa,
                    giangVien: data?.giangVien,
                    diaDiemToChuc: data?.diaDiemToChuc,
                    hocPhi: data?.hocPhi,
                    hocPhiStr: data?.hocPhi ? currencyFormat.formatMoney(data?.hocPhi) : "",
                    donViDaoTao: data?.donViDaoTao,
                    ngayBatDau: data?.ngayBatDau ? dayjs(dateCommon.formatDate(data?.ngayBatDau), "DD/MM/YYYY") : null,
                    ngayKetThuc: data?.ngayKetThuc ? dayjs(dateCommon.formatDate(data?.ngayKetThuc), "DD/MM/YYYY") : null
                });
                setTrangThai(data?.trangThai);
                setValueRadio(data.idHinhThucToChuc || 2);
                var fileHienTai: any = (data?.taiLieuTrinh || []).map((item: TaiLieu) => {
                    return {
                        uid: item.idTaiLieu + "tailieu",
                        name: item.tenTep,
                        status: 'done',
                        url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
                    };
                });
                setFileList(fileHienTai);
                setIdsTaiLieuXoa([]);
                setDsNhanVien(data.dsNhanVien);
                setTitle("Chi tiết lớp đào tạo");
                setThemMoi(false);
            }
            setLoading(false);
        } catch (error: any) {
            toast.error("Lớp đào tạo không tồn tại!");
            setLoading(false);
        }
        dispatch(hideLoadingScreen());
    }

    const onChangeDanhSachNhanVienTableModal = (data: NhanVienTheoLopDaoTao, isChecked: boolean) => {
        setDsNhanVien(prev => {
            var tempData = [...prev];
            var isExists = arrayCommon.isExisted(tempData.map(x => x.idNhanVien), data.idNhanVien);
            if (isChecked && !isExists) {
                tempData.push(data);
            }
            if (!isChecked && isExists) {
                var index = tempData.map(x => x.idNhanVien).indexOf(data.idNhanVien);
                if (index > -1) {
                    tempData.splice(index, 1);
                }
            }
            return tempData;
        });
    }

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            hocPhi: parsedValue,
            hocPhiStr: format
        });
    };

    const onFinish = (values: any) => {
        var saveData: LopDaoTao = {
            "id": parseInt(id),
            "ma": values.ma || "",
            "ten": values.ten || "",
            "moTa": values.moTa || "",
            "giangVien": values.giangVien || "",
            "diaDiemToChuc": values.diaDiemToChuc || "",
            "hocPhi": values.hocPhi || 0,
            "donViDaoTao": values.donViDaoTao || "",
            "idHinhThucToChuc": valueRadio,
            "ngayBatDau": values.ngayBatDau,
            "ngayKetThuc": values.ngayKetThuc,
            "tenHinhThucToChuc": "",
            "soLuongNhanVien": 0,
            "dsNhanVien": dsNhanVien,
            "idNVTheoDoi": values.idNVTheoDoi,
            "idPhoCVP": isTrinhPhoCVP ? phoCVP?.id : 0,
            "idPhoGiamDoc": isTrinhPhoGD ? phoGD?.id : 0,
            "idChanhVP": isTrinhCVP ? chanhVP?.id : 0,
            "idGiamDoc": isTrinhGD ? giamDoc?.id : 0,
            "isTrinh": isTrinh,
            // chỉ gửi lên các file mới chọn, file đã lưu trước đó có url
            "files": fileList.filter((x: any) => !x.url),
            "idsTaiLieuXoa": idsTaiLieuXoa
        };
        setData(saveData);
        setOpenModalLuu(true)
    };
    const onChangeRadio = (e: RadioChangeEvent) => {
        setValueRadio(e.target.value);
    };

    const onFinishNV = (values: any) => {
        setIsEdditing(false);
        setRowIndex(-1);
        editingNV.diemDanhGia = values.diemDanhGia;
        editingNV.isCapChungChi = values.isCapChungChi;
        editingNV.ketQuaDaoTao = values.ketQuaDaoTao;
    }

    useEffect(() => {
        setLoading(true);
        if (parseInt(id) > 0) {
            layCT(parseInt(id));
        }
        else {
            layDuLieuPhoCVP();
            layDuLieuChanhVP();
            layDuLieuPhoGiamDoc();
            layDuLieuGiamDoc();
            form.setFieldsValue({
                idNVTheoDoi: user.idNhanVien
            });
        }
        setLoading(false);
    }, []);
    const isNVTheoDoi = (user.idNhanVien == form.getFieldValue("idNVTheoDoi") || user.isAdmin) && (trangThai < trangThaiLopDaoTao.trinhPhoCVP ||
        (data.idPhoCVP > 0 && trangThai == trangThaiLopDaoTao.phoCVPTraLai) ||
        (data.idPhoCVP == 0 && data.idChanhVP > 0 && trangThai == trangThaiLopDaoTao.chanhVPTraLai) ||
        (data.idPhoCVP == 0 && data.idChanhVP == 0 && data.idPhoGiamDoc > 0 && trangThai == trangThaiLopDaoTao.phoGiamDocTraLai) ||
        (data.idPhoCVP == 0 && data.idChanhVP == 0 && data.idPhoGiamDoc == 0 && data.idGiamDoc > 0 && trangThai == trangThaiLopDaoTao.giamDocTraLai));
    const isPheDuyet = (user.idNhanVien == form.getFieldValue("idNVTheoDoi") || user.isAdmin) && !isTrinhPhoCVP && !isTrinhCVP && !isTrinhPhoGD && !isTrinhGD;

    return (
        <>
            <ContentHeader title={title} />
            {
                openModalLuu && <ModalTextForm show={openModalLuu}
                    title={isTrinh ? isPheDuyet ? "Phê duyệt lớp đào tạo": "Trình lớp đào tạo" : !themMoi ? "Cập nhật lớp đào tạo" : "Thêm mới lớp đào tạo"}
                    handleClose={() => { setLyDo(""); setOpenModalLuu(false); }}
                    handleSave={() => submitLuu(data)}>
                    {isTrinh ?
                        <Row>
                            <Col span="24">
                                {isPheDuyet ?
                                    <span> Bạn có muốn chuyển trạng thái lớp đào tạo thành <strong>Phê duyệt</strong> không ?Hãy nhập nội dung (nếu có):</span> :
                                    <span> Bạn có muốn <label>Trình</label> lớp đào tạo này không? Hãy nhập nội dung (nếu có):</span>}
                            </Col>
                            <Col span="24">
                                <Input.TextArea
                                    autoSize={{ minRows: 2 }}
                                    value={lyDo}
                                    onChange={(e) => {
                                        setLyDo(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row> :
                        <span>  Bạn có muốn {!themMoi ? "cập nhật lớp đào tạo" : "tạo mới lớp đào tạo"} không?</span>
                    }
                </ModalTextForm>
            }
            <section className="content" style={{ paddingBottom: "47px" }}>
                <Row>
                    <Col span={24}>
                        <Tabs accessKey={activeTab} onChange={(e) => setActiveTab(e)}
                            items={[
                                {
                                    key: "1",
                                    label: "Thông tin trình",
                                    children:
                                        <Row>
                                            <Col span="24" className="card card-body">
                                                <Form
                                                    layout="vertical"
                                                    validateMessages={validateMessages}
                                                    form={form}
                                                    onFinish={onFinish}
                                                >
                                                    <Row gutter={12}>
                                                        <Col span="6">
                                                            <Form.Item rules={[
                                                                {
                                                                    required: true
                                                                },
                                                            ]} label="Chuyên viên theo dõi" name="idNVTheoDoi">
                                                                <NhanVienSelectBox
                                                                    theoQuyen="Theo dõi đào tạo"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item name="trangThai" label="Trạng thái">
                                                                <label><TrangThaiLopDaoTaoTag value={trangThai} /></label>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={10}>
                                                            <Form.Item label="Đính kèm file trình">
                                                                <Upload {...uploadProps} multiple>
                                                                    <Button icon={<UploadOutlined rev="" />}>Chọn file đính kèm</Button>
                                                                </Upload>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={24} style={{ marginBottom: "10px" }}>
                                                            <Space>
                                                                <Checkbox
                                                                    checked={isTrinhPhoCVP}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked && phoCVP == null) {
                                                                            toast.warning("Vui lòng phân chức năng Duyệt đăng ký đào tạo tổng hợp cho Phó CVP");
                                                                            return;
                                                                        }
                                                                        setIsTrinhPhoCVP(e.target.checked)
                                                                    }}
                                                                >
                                                                    Trình Phó Chánh Văn Phòng {phoCVP ? `(${phoCVP.hoTen})` : null}
                                                                </Checkbox>

                                                                <Checkbox
                                                                    checked={isTrinhCVP}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked && chanhVP == null) {
                                                                            toast.warning("Vui lòng phân chức năng Duyệt đăng ký đào tạo tổng hợp cho Chánh VP");
                                                                            return;
                                                                        }
                                                                        setIsTrinhCVP(e.target.checked)
                                                                    }}
                                                                    style={{ marginLeft: 16 }}
                                                                >
                                                                    Trình Chánh Văn Phòng {chanhVP ? `(${chanhVP.hoTen})` : null}
                                                                </Checkbox>

                                                                <Checkbox
                                                                    checked={isTrinhPhoGD}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked && phoGD == null) {
                                                                            toast.warning("Vui lòng phân chức năng Duyệt đăng ký đào tạo tổng hợp cho Phó GĐ phụ trách Văn phòng");
                                                                            return;
                                                                        }
                                                                        setIsTrinhPhoGD(e.target.checked);
                                                                    }}
                                                                    style={{ marginLeft: 16 }}
                                                                >
                                                                    Trình Phó Giám đốc phụ trách Văn Phòng <strong>{phoGD ? `(${phoGD.hoTen})` : null}</strong>
                                                                </Checkbox>

                                                                <Checkbox
                                                                    checked={isTrinhGD}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked && giamDoc == null) {
                                                                            toast.warning("Vui lòng phân chức năng Duyệt đăng ký đào tạo tổng hợp cho Giám đốc");
                                                                            return;
                                                                        }
                                                                        setIsTrinhGD(e.target.checked)
                                                                    }}
                                                                    style={{ marginLeft: 16 }}
                                                                >
                                                                    Trình Giám đốc đơn vị {giamDoc ? `(${giamDoc.hoTen})` : null}
                                                                </Checkbox>
                                                            </Space>
                                                        </Col>
                                                        {isNVTheoDoi &&
                                                            <Form.Item style={{ position: "fixed", zIndex: 1, right: "24px", top: "120px" }}>
                                                            <Space>
                                                                <Button
                                                                    htmlType="submit"
                                                                    type="primary"
                                                                    icon={<SendOutlined />}
                                                                    onClick={() => { setIsTrinh(true) }}
                                                                >
                                                                    Lưu & Trình
                                                                </Button>
                                                                <Button type="primary" className="float-right" htmlType="submit" icon={<SaveOutlined />}
                                                                    onClick={() => {
                                                                        setIsTrinh(false);
                                                                    }}>
                                                                    Lưu
                                                                </Button>
                                                            </Space>
                                                        </Form.Item>}
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                },
                                ...(logs.length > 0 ? [
                                    {
                                        key: '2',
                                        label: "Lịch sử thao tác",
                                        children: <LogNguoiDungTable data={logs} />
                                    }
                                ] : [])
                            ]}>
                        </Tabs>
                    </Col>
                </Row>
                {activeTab != "2" &&
                    <Row>
                        <Col span={24}>
                            <Tabs
                                items={[
                                    {
                                        key: '2',
                                        label: 'Thông tin lớp đào tạo',
                                        children:

                                            <Form layout="vertical" onFinish={onFinish} validateMessages={validateMessages} form={form}>
                                                <div className="card pt-3 pb-2">
                                                    <div className="tab-content pl-3 pr-3">
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <Form.Item name="ma" label="Mã">
                                                                    <Input placeholder="Mã" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} >
                                                                <Form.Item name="ten" label="Tên lớp"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                        }
                                                                    ]}>
                                                                    <Input placeholder="Tên lớp" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8}>
                                                                <Form.Item name="giangVien" label="Giảng viên" >
                                                                    <Input placeholder="Tên giảng viên" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16}>
                                                            <Col span={8} >
                                                                <Form.Item name="hocPhiStr" label="Chi phí khóa học">
                                                                    <Input placeholder="Chi phí" prefix="₫ " onChange={handleChangeCurrency} />
                                                                </Form.Item>
                                                                <Form.Item name="hocPhi" hidden>
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8}>
                                                                <Form.Item name="diaDiemToChuc" label="Địa điểm tổ chức">
                                                                    <Input placeholder="Địa điểm tổ chức" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8}>
                                                                <Form.Item name="donViDaoTao" label="Đơn vị đào tạo">
                                                                    <Input placeholder="Đơn vị đào tạo" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <Form.Item
                                                                    name="ngayBatDau"
                                                                    label="Ngày bắt đầu"
                                                                    rules={[{ required: true }]}>
                                                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày bắt đầu" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8}>
                                                                <Form.Item
                                                                    name="ngayKetThuc"
                                                                    label="Ngày kết thúc"
                                                                    rules={[{ required: true }]}>
                                                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày kết thúc" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8}>
                                                                <Form.Item name="hinhThucToChuc" label="Hình thức tổ chức" valuePropName="checked">
                                                                    <Radio.Group onChange={onChangeRadio} value={valueRadio}>
                                                                        <Radio value={2}> Nội bộ </Radio>
                                                                        <Radio value={4}> Thuê ngoài </Radio>
                                                                    </Radio.Group>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col span={24}>
                                                                <Form.Item name="moTa" label="Mô tả">
                                                                    <TextArea rows={3} />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Form>
                                    },
                                ]}>
                            </Tabs>
                        </Col>
                        <Col span={24}>
                            <div className="card-outline">
                                <Form form={formNV} onFinish={onFinishNV}>
                                    <Tabs
                                        tabBarExtraContent=
                                        {
                                            <Button className="hrm-btn hrm-btn-warning"
                                                onClick={() => { setShowModalDSNV(true); }}
                                                icon={<PlusOutlined rev="" />}
                                            >
                                                Thêm mới
                                            </Button>
                                        }
                                        defaultActiveKey="1" items={[
                                            {
                                                key: '1',
                                                label: 'Danh sách nhân viên',
                                                children:
                                                    <Table
                                                        locale={{ emptyText: "Không có dữ liệu" }}
                                                        dataSource={dsNhanVien}
                                                        pagination={false}
                                                        rowKey="id"
                                                    >
                                                        <Column
                                                            title="STT"
                                                            key="STT"
                                                            render={(value, record, index) =>
                                                            (
                                                                <>
                                                                    {index + 1}
                                                                </>
                                                            )
                                                            }
                                                        />
                                                        <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                                        <Column className="text-center" title="Điểm đánh giá"
                                                            key="diemDanhGia"
                                                            render={(value: NhanVienTheoLopDaoTao, record, index) => (
                                                                index === rowIndex ?
                                                                    <Form.Item name="diemDanhGia">
                                                                        <Input />
                                                                    </Form.Item>
                                                                    :
                                                                    <>
                                                                        {value.diemDanhGia}
                                                                    </>
                                                            )
                                                            }
                                                        />
                                                        <Column className="text-center" title="Kết quả đào tạo"
                                                            key="ketQuaDaoTao"
                                                            render={(value: NhanVienTheoLopDaoTao, record, index) => (
                                                                index === rowIndex ?
                                                                    <Form.Item name="ketQuaDaoTao">
                                                                        <Input />
                                                                    </Form.Item>
                                                                    :
                                                                    <>
                                                                        {value.ketQuaDaoTao}
                                                                    </>
                                                            )
                                                            }
                                                        />
                                                        <Column className="text-center" title="Cấp chứng chỉ"
                                                            key="isCapChungChi"
                                                            render={(value: NhanVienTheoLopDaoTao, record, index) => (
                                                                index === rowIndex ?
                                                                    <Form.Item name="isCapChungChi" valuePropName="checked">
                                                                        <Checkbox />
                                                                    </Form.Item>
                                                                    :
                                                                    <Checkbox checked={value.isCapChungChi} disabled></Checkbox>
                                                            )
                                                            }
                                                        />
                                                        <Column className="text-center"
                                                            title="Hành động"
                                                            key="action"
                                                            render={(value: NhanVienTheoLopDaoTao, record, index) => {
                                                                return (
                                                                    <>
                                                                        <Space>
                                                                            {index === rowIndex && isEdditing ? null
                                                                                :
                                                                                <Button type="primary"
                                                                                    icon=<EditOutlined rev="" />
                                                                                    size={"small"}
                                                                                    onClick={() => {
                                                                                        setIsEdditing(true);
                                                                                        setEditingNV(value);
                                                                                        setRowIndex(index);
                                                                                        formNV.setFieldsValue({
                                                                                            diemDanhGia: value.diemDanhGia,
                                                                                            ketQuaDaoTao: value.ketQuaDaoTao,
                                                                                            isCapChungChi: value.isCapChungChi
                                                                                        })
                                                                                    }}>Sửa</Button>
                                                                            }
                                                                            {index === rowIndex && isEdditing && <Button className="btn-success" type="primary" size={"small"} icon=<SaveOutlined rev="" /> htmlType='submit'>Lưu</Button>}
                                                                            <Button type="primary"
                                                                                icon=<DeleteOutlined rev="" />
                                                                                size={"small"}
                                                                                danger
                                                                                onClick={() => {
                                                                                    onChangeDanhSachNhanVienTableModal(value, false);
                                                                                    setRowIndex(-1);
                                                                                }}>Xóa</Button>
                                                                        </Space>
                                                                    </>
                                                                )
                                                            }}
                                                        />
                                                    </Table>
                                            },
                                        ]}>
                                    </Tabs>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                }
            </section>
            {showModalDSNV ? <DanhSachNhanVienTheoDonViTableModal checklist={dsNhanVien} hide={() => setShowModalDSNV(false)} onChange={onChangeDanhSachNhanVienTableModal} idLopDaoTao={parseInt(id)} /> : null}

        </>
    )
}

export default ChiTietLopDaoTao;